import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from 'src/app/shared/environment.service';

@Injectable({
  providedIn: 'root'
})
export class ManageProfileService {
  baseUrl = 'staffs/profile';
  headers = this.env.getLoginHeaders();
  constructor(
    public http: HttpClient, public env: EnvironmentService
  ) { }
  getStaffData(){
    let url = `${this.baseUrl}`;
    return this.env.get(url);
  }

  //change staff profile image
  uploadStaffImage(params:any){
    let url = `${this.baseUrl}/profile-image`;
    return this.env.patchFormData(url,params);
  }

  changePassword(params:any){
    let url = `${this.baseUrl}/change-password`;
    return this.env.patch(url,params);
  }
}
